var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkIndicatorNormalMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 22.7,
    height: 22.7,
    rx: 11.35,
    fill: "#E6F3E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 22.7,
    height: 22.7,
    rx: 11.35,
    stroke: "#005C00",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12181_46837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8701 17.3827C12.4445 17.3827 12.9101 16.9171 12.9101 16.3427C12.9101 15.7684 12.4445 15.3027 11.8701 15.3027C11.2957 15.3027 10.8301 15.7684 10.8301 16.3427C10.8301 16.9171 11.2957 17.3827 11.8701 17.3827Z",
    fill: "#005C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5246 9.25185C16.6483 7.71305 14.2968 6.87207 11.8702 6.87207C9.44364 6.87207 7.09207 7.71305 5.21582 9.25185",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4765 11.5442C15.1653 10.5062 13.5419 9.94141 11.8696 9.94141C10.1972 9.94141 8.57391 10.5062 7.2627 11.5442",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4293 13.847C13.6856 13.3061 12.7896 13.0146 11.8699 13.0146C10.9503 13.0146 10.0543 13.3061 9.31055 13.847",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12181_46837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.38,
    height: 16.38,
    fill: "white",
    transform: "translate(4.45996 3.80957)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIndicatorNormalMobile);
export default __webpack_public_path__ + "static/media/network_indicator_normal_mobile.05fdf379e797b2518380aa1f6e3cf288.svg";
export { ForwardRef as ReactComponent };